import {useParams} from 'react-router-dom'

export const useCollectionId = () => {
  const {collectionId} = useParams()
  if (!collectionId) throw new Error('Missing :collectionId')
  return collectionId
}

export const useDocumentId = () => {
  const {documentId} = useParams()
  if (!documentId) throw new Error('Missing :documentId')
  return documentId
}

export const useDocumentVersionId = (): string => {
  const {documentVersionId} = useParams()
  if (!documentVersionId) throw new Error('Missing :documentVersionId')
  return documentVersionId
}
